/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_Failure_ShortInputs */

const en_us2_workout_logging_kind_failure_short = /** @type {(inputs: Workout_Logging_Kind_Failure_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failure`)
};

const pt_br2_workout_logging_kind_failure_short = /** @type {(inputs: Workout_Logging_Kind_Failure_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha`)
};

const es_419_workout_logging_kind_failure_short = /** @type {(inputs: Workout_Logging_Kind_Failure_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo`)
};

const pt_pt2_workout_logging_kind_failure_short = /** @type {(inputs: Workout_Logging_Kind_Failure_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha`)
};

const fr_fr2_workout_logging_kind_failure_short = /** @type {(inputs: Workout_Logging_Kind_Failure_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec`)
};

const de_de2_workout_logging_kind_failure_short = /** @type {(inputs: Workout_Logging_Kind_Failure_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versagen`)
};

const it_it2_workout_logging_kind_failure_short = /** @type {(inputs: Workout_Logging_Kind_Failure_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cedimento`)
};

/**
* | output |
* | --- |
* | "Failure" |
*
* @param {Workout_Logging_Kind_Failure_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_failure_short = /** @type {((inputs?: Workout_Logging_Kind_Failure_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_Failure_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_failure_short(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_failure_short(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_failure_short(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_failure_short(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_failure_short(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_failure_short(inputs)
	return en_us2_workout_logging_kind_failure_short(inputs)
});
export { workout_logging_kind_failure_short as "workout-logging.kind_failure_short" }